import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({ apidata, columns, searchBy }) {
  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [statusCounts, setStatusCounts] = useState({
    Pending: 0,
    "In-Progress": 0,
    Hired: 0,
    Rejected: 0,
    Closed: 0,
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    city: "",
    jobId: "",
    fromDate: "",
    toDate: "",
    createdBy: "", // ✅ NEW FILTER
  });

  // ✅ APPLY SEARCH + ALL FILTERS
  useEffect(() => {
    let filtered = apidata;

    // 🔍 Search filter (by name)
    if (dataFilter) {
      filtered = filtered.filter((item) =>
        item.name?.toLowerCase().includes(dataFilter.toLowerCase()),
      );
    }

    // 🟢 Status filter
    if (filters.status) {
      filtered = filtered.filter(
        (item) =>
          item.status &&
          item.status.toLowerCase() === filters.status.toLowerCase(),
      );
    }

    // 🏙️ City filter
    if (filters.city) {
      filtered = filtered.filter(
        (item) =>
          item.jobId &&
          item.jobId.city &&
          item.jobId.city.toLowerCase() === filters.city.toLowerCase(),
      );
    }

    // 💼 Job ID filter
    if (filters.jobId) {
      filtered = filtered.filter(
        (item) =>
          item.jobId && item.jobId.jobId && item.jobId.jobId === filters.jobId,
      );
    }

    // 📅 Date filter
    if (filters.fromDate || filters.toDate) {
      filtered = filtered.filter((item) => {
        if (!item.date) return false;

        // Extract YYYY-MM-DD
        const candidateDate = item.date.split("T")[0];

        if (filters.fromDate && candidateDate < filters.fromDate) {
          return false;
        }

        if (filters.toDate && candidateDate > filters.toDate) {
          return false;
        }

        return true;
      });
    }

    // ✅ ✅ ✅ CREATED BY FILTER (USER / TEAM)
    // if (filters.createdBy) {
    //   filtered = filtered.filter(
    //     (item) => item.createdBy === filters.createdBy
    //   );
    // }
    if (filters.createdBy === "USER") {
      filtered = filtered.filter(
        (item) => item.createdBy === "public" || item.createdBy === "user",
      );
    }

    if (filters.createdBy === "TEAM") {
      filtered = filtered.filter((item) =>
        ["admin", "superadmin", "clientmanager"].includes(item.createdBy),
      );
    }

    setFilteredData(filtered);
    const counts = {
      Pending: 0,
      "In-Progress": 0,
      Hired: 0,
      Rejected: 0,
      Closed: 0,
    };

    filtered.forEach((item) => {
      const status = item.status?.trim();

      if (counts.hasOwnProperty(status)) {
        counts[status]++;
      }
    });

    setStatusCounts(counts);
  }, [dataFilter, apidata, searchBy, filters]);

  const applyFilters = (filterValues) => {
    setFilters(filterValues);
  };

  const removeFilters = () => {
    setFilters({
      status: "",
      city: "",
      jobId: "",
      // date: "",
      fromDate: "",
      toDate: "",

      createdBy: "", // ✅ RESET
    });
  };

  // return (
  //   <div className="table-responsive">
  //     <div className="row justify-content-between mb-2">
  //       <div className="row mb-3">
  //         <div className="col-md-3 mb-2">
  //           <div className="card border-success">
  //             <div className="card-body py-2">
  //               <div className="text-muted">Pending</div>
  //               <h4 className="mb-0">{statusCounts.Pending}</h4>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="col-md-3 mb-2">
  //           <div className="card border-warning">
  //             <div className="card-body py-2">
  //               <div className="text-muted">In-Progress</div>
  //               <h4 className="mb-0">{statusCounts["In-Progress"]}</h4>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="col-md-3 mb-2">
  //           <div className="card border-primary">
  //             <div className="card-body py-2">
  //               <div className="text-muted">Hired</div>
  //               <h4 className="mb-0">{statusCounts.Hired}</h4>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="col-md-3 mb-2">
  //           <div className="card border-danger">
  //             <div className="card-body py-2">
  //               <div className="text-muted">Rejected</div>
  //               <h4 className="mb-0">{statusCounts.Rejected}</h4>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="col-md-3 mb-2">
  //         <input
  //           type="text"
  //           placeholder={`Search by ${searchBy}`}
  //           className="form-control"
  //           value={dataFilter}
  //           onChange={(e) => setDataFilter(e.target.value)}
  //         />
  //       </div>
  //       <div className="col-md-9 mb-2">
  //         <button
  //           className="btn btn-primary"
  //           onClick={() => setShowFilterModal(true)}
  //         >
  //           Filter
  //         </button>
  //       </div>
  //     </div>

  //     {filteredData.length > 0 ? (
  //       <DataTable
  //         columns={columns}
  //         data={filteredData}
  //         pagination
  //         fixedHeader
  //         highlightOnHover
  //         responsive
  //         paginationPerPage={5}
  //         paginationRowsPerPageOptions={[5, 10, 15, 20]}
  //       />
  //     ) : (
  //       <div className="row justify-content-start">
  //         <div className="col-12">
  //           <p>No results found.</p>
  //         </div>
  //       </div>
  //     )}

  //     <FilterModal
  //       show={showFilterModal}
  //       onHide={() => setShowFilterModal(false)}
  //       applyFilters={applyFilters}
  //       removeFilters={removeFilters}
  //       apidata={apidata}
  //     />
  //   </div>
  // );
  return (
    <div className="table-responsive">
      <div className="row align-items-center mb-3">
        {/* Search */}
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>

        {/* Filter + Status Counts */}
        <div className="col-md-9 mb-2">
          <div className="d-flex align-items-center justify-content-between">
            {/* Filter Button */}
            <button
              className="btn btn-primary"
              onClick={() => setShowFilterModal(true)}
            >
              Filter
            </button>

            {/* Status Counts */}
            <div className="d-flex align-items-center gap-3">
              <div
                className="px-3 py-1"
                style={{
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Pending: {statusCounts.Pending}
              </div>

              <div
                className="px-3 py-1"
                style={{
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                In-Progress: {statusCounts["In-Progress"]}
              </div>

              <div
                className="px-3 py-1"
                style={{
                  backgroundColor: "#198754",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Hired: {statusCounts.Hired}
              </div>

              <div
                className="px-3 py-1"
                style={{
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Rejected: {statusCounts.Rejected}
              </div>

              <div
                style={{
                  padding: "5px 10px",
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                }}
              >
                Closed: {statusCounts.Closed}
              </div>
            </div>
          </div>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
      />
    </div>
  );
}
